
<template>
  <div id="page_product">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-toolbar color="primary" dark flat dense cad>
          <v-toolbar-title class="subheading">Edit Product</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-xs-left">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-layout fluid row wrap>
              <v-flex lg3 sm6 xs12>
                <v-text-field class="pr-3" label="Product Code" name="kode" v-model="adddata.kode"></v-text-field>
              </v-flex>
              <v-flex lg9 sm12 xs12>
                <v-text-field label="Product Name" name="nama" v-model="adddata.nama"></v-text-field>
              </v-flex>
              <v-flex lg12 sm12 xs12>
                <v-textarea
                  auto-grow
                  rows="1"
                  label="Description"
                  name="catatan"
                  v-model="adddata.catatan"
                ></v-textarea>
              </v-flex>
              <v-flex lg12 sm12 xs12>
                <v-textarea
                  auto-grow
                  rows="1"
                  label="Kode Operator"
                  name="kode_operator"
                  v-model="adddata.kode_operator"
                ></v-textarea>
              </v-flex>
              <v-flex lg4 sm12 xs12>
                <v-text-field
                  type="number"
                  class="pr-3"
                  label="Price"
                  name="Price"
                  id="price"
                  v-model="adddata.harga_jual"
                ></v-text-field>
              </v-flex>

              <v-flex lg4 sm12 xs12>
                <v-select
                  label="Status"
                  class="pr-3"
                  item-text="text"
                  item-value="aktif"
                  v-model="adddata.aktif"
                  :items="statuses"
                ></v-select>
              </v-flex>

              <v-flex lg4 sm12 xs12>
                <v-select
                  label="Gangguan"
                  item-text="text"
                  item-value="aktif"
                  v-model="adddata.gangguan"
                  :items="gangguans"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeform()">
            <v-icon>close</v-icon>Close
          </v-btn>
          <v-btn color="success" @click="simpanForm(adddata)">
            <v-icon>save</v-icon>Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-btn color="primary" @click.native="getNews()">
                <v-icon dark>refresh</v-icon>Refresh
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="list"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                select-all
                :loading="loading"
                v-model="complex.selected"
              >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
export default {
  components: {},
  data: () => ({
    state_add: false,
    search: '',
    statuses: [
      {
        aktif: 1,
        text: 'Aktif'
      },
      {
        aktif: 0,
        text: 'Non-Aktif'
      }
    ],
    gangguans: [
      {
        aktif: 1,
        text: 'Yes'
      },
      {
        aktif: 0,
        text: 'No'
      }
    ],
    selected_combo: '',
    applist: [{ text: 'BeliStok', value: 1 }, { text: 'WartoMAx', value: 2 }],
    editorOption: {},
    valid: false,
    complex: {
      selected: [],
      headers: [
        {
          text: 'Code',
          value: 'kode'
        },
        {
          text: 'Name',
          value: 'nama'
        },
        {
          text: 'Category',
          value: 'alamat'
        },
        {
          text: 'Price',
          value: 'harga_jual'
        },
        {
          text: 'Poin',
          value: 'kode_upline'
        },
        {
          text: 'Active',
          value: 'aktif'
        },
        {
          text: 'Updated At',
          value: 'updated_at'
        },
        {
          text: 'Action',
          value: ''
        }
      ],
      items: []
    },
    delete_id: '',
    adddata: {
      appid: '',
      name: '',
      order: 1,
      status: 1,
      url: 'https',
      image: '',
      kode: '',
      nama: '',
      gangguan: 0,
      kosong: 0
    }
  }),
  created () {
    // this.getApplist();
  },
  mounted () {
    this.getNews()
  },
  computed: {
    ...mapState('Product', ['list', 'dialog', 'loading'])
  },
  methods: {
    ...mapActions({
      logout: 'account/logout',
      AddNew: 'Product/Add',
      closeDialog: 'Product/closeDialog',
      OpenDialogForm: 'Product/OpenDialogForm',
      getNews: 'Product/GETLIST',
      delete_news: 'Product/Delete'
    }),
    closeform () {
      this.adddata.name = ''
      this.adddata.image = ''
      this.adddata.url = ''
      this.adddata.appid = ''
      this.closeDialog()
      this.state_add = false
      this.getNews()
    },
    OpenFormEdit (data) {
      this.adddata = data
      this.state_add = false
      this.OpenDialogForm()
    },
    openmodal () {
      this.state_add = true
      this.OpenDialogForm()
    },
    simpanForm (data) {
      if (this.state_add) {
        this.AddNew(data)
      } else {
        this.AddNew(data)
      }
      this.state_add = false
      this.adddata.name = ''
      this.adddata.image = ''
      this.adddata.url = ''
      this.adddata.appid = ''
      this.getNews()
    },
    deleteItem (data) {
      this.delete_id = data.id
      // if (confirm("Are you sure you want delete ?")) {
      //  this.delete_news(this.delete_id);
      //  this.getNews();
      // }
      this.$confirm('Do you really want to delete ' + data.kode + ' ?', {
        title: 'Confirm',
        color: 'blue',
        icon: 'fa fa-question-circle'
      }).then(res => {
        if (res) {
          this.delete_news(this.delete_id)
          this.getNews()
        }
      })
    },
    formatNumber (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return val.replace(',00', '')
    },
    formatDate (value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    },
    formatActive (value) {
      return value
    }
  }
}
</script>

<style lang="stylus" scoped>
.quill {
  height: 300px;
  padding-bottom: 95px;
}

.tdlist {
  padding: 10px !important;
}

.padding-left {
  padding-left: 10px !important;
}

.imgslide {
  width: 100%;
  height: 200px;
}

.imgslidelist {
  width: 300px;
  height: 100px;
}

.right-input input {
  text-align: right !important;
}
</style>
